import { connect } from 'react-redux';

import { getLoginRequestStatus } from '../../reducers/selectors';

import {
  loginWithUsername,
  logout,
  authWithSSO,
  beginIdpAuthRedirect,
  ssoAuthError,
  ssoIdpAuthStart,
  ssoIdpAuthReceiveCode,
  ssoIdpAuthReceiveToken,
} from '../../actions';

import LoginView from './LoginView';
import { NEX_ORG_SWITCH_REQUEST } from '../../constants/actionTypes';

const mapStateToProps = (state, ownProps) => {
  const { session, request } = state;
  return {
    session,
    isLoggingIn: getLoginRequestStatus(state),
    isOrgSwitchLoading: !!request[NEX_ORG_SWITCH_REQUEST],
  };
};

export default connect(mapStateToProps, {
  loginWithUsername,
  logout,
  authWithSSO,
  beginIdpAuthRedirect,
  ssoAuthError,
  ssoIdpAuthStart,
  ssoIdpAuthReceiveCode,
  ssoIdpAuthReceiveToken,
})(LoginView);
